import { Field, Form, Formik } from "formik";
import { useRef } from "react";
import { Modal } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import validationSchema from "../../../Validation/ValidationSchemas";

const TestimonialModal = ({
  openModal,
  testimonial,
  closeModal,
  fileName,
  changeHandlertestimonials,
  setTestimonial,
  setName,
  name,
  setCaptian,
  captian,
  setContent,
  content,
  handleForm,
}) => {
  const formRef = useRef();
  const onFieldChange = (event) => {
    setTestimonial((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const handleSubmitForm = () => {
    formRef.current.handleSubmit();
  };
  return (
    <div>
      <Formik
        innerRef={formRef}
        initialValues={{
          image: testimonial
            ? testimonial.uploadedLogo.fileName.slice(0, 15)
            : fileName,
          testimonialHeading: testimonial ? testimonial.name : name,
          testimonialDescription: testimonial ? testimonial.content : content,
          testimonialCaptian: testimonial ? testimonial.captian : captian,
        }}
        validationSchema={validationSchema.addOrEditTestimonialSchema}
        enableReinitialize
        onSubmit={(values) => handleForm(values)}
      >
        {(formik) => (
          <Form>
            <div>
              {openModal && (
                <Modal id="mwidth" show={true}>
                  <Modal.Header>
                    <div className="d-flex justify-content-between w-100">
                      <h1 className="fs-20 semi-bold">
                        {testimonial ? "Edit Testimonial" : "Add Testimonial"}
                      </h1>
                      <BsXLg
                        onClick={closeModal}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    <label className="fs-18 semi-bold">ICON IMAGE</label>
                    <div>
                      <label
                        htmlFor="filePicker"
                        className="browseBTN"
                        style={{ padding: "12px 10px" }}
                      >
                        <u>Browse</u>
                      </label>
                      <span className="pl-3 fs-18 medium newgreyTXT">
                        {testimonial
                          ? testimonial.uploadedLogo.fileName.slice(0, 15)
                          : fileName
                          ? fileName.slice(0, 15)
                          : "No file chosen"}
                      </span>
                      <input
                        id="filePicker"
                        style={{ visibility: "hidden" }}
                        type={"file"}
                        onChange={(e) => changeHandlertestimonials(e, formRef)}
                      ></input>
                      <p className=" imgsizeTXT text-dark">
                        Image Size : 80 px * 80 px
                      </p>
                      <div className="errorMsg fs-14 medium">
                        {formik.errors.image}
                      </div>
                    </div>
                    <p className="fs-18 semi-bold black">
                      TITLE{" "}
                      <span className="fs-16 regular newgreyTXT">
                        (Character Limit 20)
                      </span>
                    </p>
                    <div className="clear10"></div>
                    <Field
                      type="text"
                      name="testimonialHeading"
                      className={`form-control w-100 faqtextbox1 ${
                        formik.errors.testimonialHeading && "is-invalid"
                      }`}
                      placeholder="Title"
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.errors.testimonialHeading}
                    </div>
                    <div className="clear10"></div>

                    <p className="fs-18 semi-bold black">
                      Captian <span className="fs-16 regular newgreyTXT"></span>
                    </p>
                    <div className="clear10"></div>
                    <Field
                      type="text"
                      name="testimonialCaptian"
                      className={`form-control w-100 faqtextbox1 ${
                        formik.errors.testimonialCaptian && "is-invalid"
                      }`}
                      placeholder="Captian"
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.errors.testimonialCaptian}
                    </div>

                    <div className="clear10"></div>
                    <p className="fs-18 semi-bold black">
                      DECRIPTION{" "}
                      <span className="fs-16 regular newgreyTXT">
                        (Character Limit 140)
                      </span>
                    </p>
                    <div className="clear10"></div>
                    <Field
                      as="textarea"
                      rows="3"
                      col="12"
                      // id="comment"
                      name="testimonialDescription"
                      className={`form-control fs-16 w-100 faqanswerbox ${
                        formik.errors.testimonialDescription && "is-invalid"
                      }`}
                      placeholder="Use video and data analysis to detect vulnerabilities. Decide what to focus on and develop technical and tactical strategies to improve performance and reduce injuries."
                    />
                    <div className="errorMsg fs-14 medium">
                      {formik.errors.testimonialDescription}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="d-flex-align-cent mg-top-20">
                      <button type="button" className="cancelbtn mr-2">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className={`${
                          formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                        }`}
                        disabled={!formik.isValid}
                        onClick={() => handleSubmitForm()}
                      >
                        Save
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TestimonialModal;
